import { Alert, Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { ArrowRotateRight } from 'iconsax-reactjs';

import { t } from '../i18n';

export function TenantUnavailablePage({ onRetry }: { onRetry: () => Promise<void> }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default', p: 3 }}>
      <Card sx={{ width: '100%', maxWidth: 460 }}>
        <CardContent>
          <Stack spacing={2.5}>
            <Stack spacing={0.75}>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {t('shell.tenantUnavailable.title')}
              </Typography>
              <Typography color="text.secondary">
                {t('shell.tenantUnavailable.body')}
              </Typography>
            </Stack>
            <Alert severity="warning">
              {t('shell.tenantUnavailable.alert')}
            </Alert>
            <Button
              variant="contained"
              startIcon={<ArrowRotateRight size={18} />}
              onClick={() => void onRetry()}
            >
              {t('shell.tenantUnavailable.retry')}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
